import React, { useRef } from "react";
import { useNavigate } from 'react-router-dom';
import { useInView } from "react-intersection-observer";
import { Link } from "react-router-dom";
import { motion, Variants } from "framer-motion";
import Scroll from '../../Layout/SmoothScroll';
import { useState } from "react";
function Article12() {
  const imageRef = useRef(null);

  const { ref: firstContainer, inView: firstInView } = useInView({
    threshold: 0
  });

  const { ref: secondContainer, inView: secondInView } = useInView({
    threshold: 0
  });

  const { ref: thirdContainer, inView: thirdInView } = useInView({
    threshold: 0
  });

  const { ref: fourContainer, inView: fourInView } = useInView({
    threshold: 0
  });

  const { ref: fiveContainer, inView: fiveInView } = useInView({
    threshold: 0
  });

  const { ref: sixContainer, inView: sixInView } = useInView({
    threshold: 0
  });

  const { ref: sevenContainer, inView: sevenInView } = useInView({
    threshold: 0
  });

  const { ref: eightContainer, inView: eightInView } = useInView({
    threshold: 0
  });

  const { ref: nineContainer, inView: nineInView } = useInView({
    threshold: 0
  });

  const { ref: tenContainer, inView: tenInView } = useInView({
    threshold: 0
  });

  const { ref: elevenContainer, inView: elevenInView } = useInView({
    threshold: 0
  });



  const getAnimationClass = () => {
    if (firstInView) {
      var img1 = document.getElementById("img1");
      img1.className = 'active';
      var img2 = document.getElementById("img2");
      img2.className = '';
      return "";
    }

    else if (secondInView) {
      var img1 = document.getElementById("img1");
      img1.className = '';
      var img2 = document.getElementById("img2");
      img2.className = 'active';
      return "";
    }
    
    
  };

  const textAnimate = {
    offscreen: { y: 10, opacity: 0 },
    onscreen: {
      y: 0,
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        duration: 0.5
      }
    }
  }
  const imgAnimate = {
    offscreen: { opacity: 0 },
    onscreen: {
      opacity: 1,
      transition: {
        type: "spring",
        bounce: 0.25,
        delay: 0.5,
        duration: 0.5
      }
    }
  }

  const [addClass, setAddClass] = useState(false);
  const navigate = useNavigate();

  const handleClick = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article13');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick1 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/article11');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  const handleClick2 = () => {
    setAddClass(true);
      // Call your function here
    setTimeout(() => {
      navigate('/');
      
    }, 1000); // Delay of 2000 milliseconds (2 seconds)
    
  };

  return (
    <motion.div
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 1 }}
    >
      <Scroll />
      <motion.div
        initial={"offscreen"}
        whileInView={"onscreen"}
        viewport={{ once: false, amount: 0.5 }}
        transition={{ staggerChildren: 0.25 }}
        className="magazine-wrap article-wrap"
      >
        <motion.div
          variants={imgAnimate}
          className="article-left"
        >
          {/* {getImage()} */}
          <img id="img1" className="active" src={require("../../Images/article12-left-img1.jpg")} />
          <img id="img2" className={getAnimationClass()} src={require("../../Images/article12-left-img2.jpg")} />
        </motion.div>
        <div className="article-right scroll-sec">
          <motion.div variants={textAnimate} className="article-left-mob">
            <img src={require("../../Images/article12-left-img1.jpg")} alt="" />
          </motion.div>

          <motion.div
            variants={textAnimate}
            className="hamburger-menu mb-4 mb-sm-5">
            <Link to="/">
              <img
                src={require("../../Images/hamburger-menu-icon.png")}
              />
            </Link>
          </motion.div>
          <div className="article-mob-wrap">
            <div className="" ref={firstContainer}>
              <h1 className="fs-xl f-lora mb-4 text-gold">Truly Scottish <br/>Sporting Traditions</h1>
              <p className="f-lora-i lh-base mb-4 mb-sm-5" variants={textAnimate}>words // Graeme Johncock - photography // Jack Cairney</p>

              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">
                  <p className="" variants={textAnimate}>Is there anything that embodies the traditions of Scotland quite as much as the Highland Games? </p>
                  <p className="" variants={textAnimate}>The skirling of pipes alongside crashing drums. Flashes of tartan as Highland dancers leap over swords. The sight and sound of powerful figures throwing enormous objects. A visit to the Highland Games offers a wide range of spectacles beyond the famous heavy events, each one united by a very long history. </p>
                  <p className="" variants={textAnimate}>The celebrations held today can be called the modern Highland Games, resurrected in the 1800s, but with roots that go back much further. To discover those, legend sends us to Braemar – often considered the home of the Highland Games and regularly visited by members of the Royal Family. </p>
                  <p className="" variants={textAnimate}> </p>
                </div>
                <div className="col-sm-6">
                  <p className="" variants={textAnimate}>Speed was of the essence, so Malcolm ordered every man to run to the top of Creag Chòinnich and back. </p>
                  <p className="" variants={textAnimate}>The winner of the footrace gained the prestigious title of Royal Messenger and so the Highland Games were born. That tradition of setting physical challenges to determine the fastest, strongest or fittest warriors in a community was soon deeply ingrained in Scottish culture. </p>
                  <p className="" variants={textAnimate}>They quickly spread across the country and now we have games of all sizes, from small, local affairs such as Strathardle, right up to Cowal Highland Gathering, the largest in Scotland. From Gourock in May to Pitlochry in September, not a week passes without a rousing Highland Games taking place somewhere. All are designed to bring communities together and many have their own local traditions or stories to tell, such as the Ceres Games. </p>
                </div>
              </div>

              <div className="row mb-4">
                <div className="col-6">
                  <img className="img-fluid"
                    src={require("../../Images/article12-right-img1.jpg")}
                  />
                </div>
                <div className="col-6">
                  <img className="img-fluid"
                    src={require("../../Images/article12-right-img2.jpg")}
                  />
                </div>
              </div>

              <img className="img-fluid mb-4"
                src={require("../../Images/article12-right-img3.jpg")}
              />

              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">
                  <p className="" variants={textAnimate}>Although not technically in the Highlands, Ceres can claim to be one of the oldest gatherings dating back to 1314. It’s said that the first games took place to celebrate the return of the Ceres men from the Battle of Bannockburn. Over 700 years later, locals still compete on the same village green as those historic warriors once did. </p>
                  <p className="" variants={textAnimate}>It’s easy to see how certain competitions at the Highland Games could be used to judge the best warriors, with some events gaining worldwide recognition. They don’t get much simpler than throwing a stone, often sourced from a local river, which was later adopted into the Olympics as the Shot Put. </p>
                  <p className="mb-4" variants={textAnimate}>Others are a little more nuanced, with the iconic tossing the caber not a test of strength, but one of control. Rather than measuring how far this small tree is thrown, the challenge is to see how straight it lands after spinning in the air. The perfect toss has the caber landing at exactly 12 o’clock. While nobody knows for sure, one theorised origin comes from throwing logs safely across Scotland’s many rivers before the days of regular bridges. </p>
                  <div className="mb-3 text-center">
                    <img className="img-fluid"
                      src={require("../../Images/article12-right-img4.jpg")}
                    />
                  </div>
                  
                </div>
                <div className="col-sm-6">
                  <p className="" variants={textAnimate}>Even the Highland dancing competition was once an important tradition for fighting men. As anybody who has attempted one of these dances will tell you, they take incredible stamina and agility to complete. </p>
                  <p className="" variants={textAnimate}>War dances to the sound of bagpipes were performed at the wedding of Alexander III in 1285 and Scots danced around swords for the Swedish King in 1573. Another sword dance was even performed for Charles I on a floating stage in the River Tay. </p>
                  <p className="" variants={textAnimate}>Tradition claims that the dance Seann Triubhas or Old Trousers was a form of protest against the Act of Proscription which banned most people from wearing Highland Dress. Starting with slow leg movements as if shaking trousers off, it ends much quicker now the dancer is freed from obstruction. </p>
                  <p className="" variants={textAnimate}>One of the greatest champions of the Highland Games was Donald Dinnie from Aberdeenshire, winning 21 titles in a row from 1856 to 1876. He went on to tour the world, winning over 10,000 competitions and becoming known as the greatest athlete of the 19th century, not just for immense strength but also speed and agility. </p>
                  <p className="" variants={textAnimate}>The Scotsman’s most famous feat, however, was something much simpler. Outside the Potarch Café sit two large boulders fitted with iron rings, now known as the Dinnie Stones. In 1860, while working on the Potarch Bridge with his stonemason father, Donald Dinnie carried these scaffolding counterweights across the width of the bridge, 17 feet 1.5 inches. </p>
                  <p className="" variants={textAnimate}>Together, they weigh 332kg and over the last 160 years, only a handful of people have ever replicated that feat, including Donald’s father. Most challengers settle for putting wind under the stones by lifting them both clear off the ground. While it might seem like a test reserved for hulking mountains, Donald Dinnie himself was only 6ft 1 inch, weighing a modest 15 stone. </p>
                  <p className="" variants={textAnimate}>The Dinnie Stones might be the most famous lifting stones in Scotland, but they’re just one example of a widespread Scottish tradition. While the Highland Games are all about bringing communities together, lifting stones are a personal challenge. In many locations, it’s thought that these were a test of manhood, with boys finally coming of age when they were strong enough to lift the clan stone. </p>
                </div>
              </div>

            </div>

            <div className="" ref={secondContainer}>
              <img className="img-fluid mb-4"
                src={require("../../Images/article12-right-img5.jpg")}
              />
              <div className="row mb-4">
                <div className="col-sm-6">
                  <img className="img-fluid mb-3"
                    src={require("../../Images/article12-right-img6.jpg")}
                  />
                   <p className="" variants={textAnimate}>The Inver stone with the late June and Jim Richard. June welcomed weightlifters from all over the world to her garden at Creagan Ruadh Cottage to lift the stone. The Stone is now kept at the Braemar Highland Games Centre, accompanied by a plaque in memory of June. </p>
                </div>
                <div className="col-sm-6">
                  <img className="img-fluid"
                    src={require("../../Images/article12-right-img7.jpg")}
                  />
                </div>
              </div>
              <img className="img-fluid mb-4"
                src={require("../../Images/article12-right-img8.jpg")}
              />
              <div className="row mb-4 mb-sm-5">
                <div className="col-sm-6">
                  <p className="" variants={textAnimate}>The Inver Stone is one of the more famous examples, once sitting outside an inn for travellers to pass the time. It spent part of its life as an official weight for measuring grain, being engraved with 265lb, before being left beside Creagan Ruadh Cottage for brave individuals to attempt. Now found at Braemar Highland Games Centre, the Inver Stone can only be attempted by appointment. </p>
                  <p className="" variants={textAnimate}>While some stones are to be lifted or carried, the Puterach Stone in Balquhidder must be placed on its own special plinth known as the Pudrac. At four feet high, it’s no mean feat to raise the 94kg stone atop. Some believe it to have been a test for local MacLarens or MacGregors and that the legendary Rob Roy, who lies buried nearby, was one of the successful lifters. </p>
                  <p className="" variants={textAnimate}>The old tradition of lifting stones has been resurrected in recent years, with competitors travelling Scotland, conquering as many as possible. For others, the appeal comes from the stories behind specific challenges like the Dinnie Stones. </p>
                  <p className="" variants={textAnimate}>While both Highland Games and lifting stones vary everywhere you go, one thing remains constant. They’re all much more than just sporting challenges; they’re enduring symbols of Scottish tradition and culture. </p>
                  
                </div>
                <div className="col-sm-6">
                  <img className="img-fluid"
                    src={require("../../Images/article12-right-img9.jpg")}
                  />
                </div>
              </div>

            </div>

          </div>
        </div>
      </motion.div>
      <div className="btns-group">
        <button className="btn nxtPrv-btn" onClick={handleClick1}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z" /></svg>
        </button>
        <button className="btn home-btn" onClick={handleClick2}> Contents </button>
        <button className="btn nxtPrv-btn" onClick={handleClick}>
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z" /></svg>
        </button>
      </div>
      <button className={addClass ? 'active fold' : 'fold'} onClick={handleClick}></button>

      <div className={addClass ? 'active1 unfold' : 'unfold'}></div>
    </motion.div>

  );
}

export default Article12;
